import { FC } from "react";
import PermissionWebLayout from "./WebLayout";

const Permission: FC = () => {
  return (
    <div>
      <PermissionWebLayout />
    </div>
  );
};

export default Permission;
